import { createFileRoute } from '@tanstack/react-router'
import { lazy } from 'react'

import { assertDevelopmentBuild, DevPreviewUnavailable } from '@/spa/dev-only'

// The ternary is folded by Rollup in a production build, so the preview chunk
// is never emitted. See DevPreviewUnavailable in @/spa/dev-only.
const component = import.meta.env.DEV
  ? lazy(() =>
      import('@/features/platform-status/pages/dev-platform-status-preview').then((m) => ({
        default: m.PlatformStatusDevPreview,
      })),
    )
  : DevPreviewUnavailable

export const Route = createFileRoute('/_bare/dev/platform-status-preview')({
  beforeLoad: assertDevelopmentBuild,
  component,
})
